import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { TextField } from '../TextField';
import { DataTableProps, DataTableSearchProps } from './types';
import { ColumnButton } from '../ColumnButton';

export function DataTableSearch<T extends string>({
  condensed,
  onSearch,
  searchTerm,
  searchableColumns
}: DataTableProps<T> & DataTableSearchProps) {
  if (!searchableColumns) {
    return null;
  }

  return (
    <div className="p-2 border-b border-column-gray-200 bg-column-gray-50">
      <TextField
        id="data-table-search"
        role="searchbox"
        labelText={undefined}
        placeholder="Search"
        value={searchTerm}
        onChange={onSearch}
        size={condensed ? 'xs' : 'sm'}
        prefix={
          <MagnifyingGlassIcon
            className="w-4 h-4 text-column-gray-300"
            aria-hidden
          />
        }
        suffix={
          searchTerm && (
            <ColumnButton
              aria-label="clear search"
              startIcon={<XMarkIcon className="w-4 h-4 text-column-gray-300" />}
              onClick={() => onSearch('')}
              type="button"
              link
            />
          )
        }
      />
    </div>
  );
}
